import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const TransportationDropdown = ({ transportationList = [], transportationCompanyName, sendTransportationChildData }) => {
    const { t } = useTranslation();
    const dropdownRef = useRef(null);
    const [showTransportation, setShowTransportation] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowTransportation(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    const filteredList = transportationList.filter(company =>
        company.text.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleTransportation = (e, value) => {
        e.preventDefault();
        setShowTransportation(!showTransportation);
        sendTransportationChildData(value);
    };

    return (
        <div ref={dropdownRef} className="w-auto relative">
            <div onClick={() => setShowTransportation(!showTransportation)}>
                <button className="bg-background-normal justify-between font-normal text-base px-3 py-3 rounded-md inline-flex w-full">
                    <span className={(transportationCompanyName.length > 0 ? "text-black" : "text-gray-dark") + " mr-4 text-xs sm:text-sm text-left"}>
                        {(transportationCompanyName.length > 0) ? <span className="text-xs">{transportationCompanyName}</span> : t('select transportation company')}
                    </span>
                    <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                </button>
            </div>
            {showTransportation && (
                <ul className="min-h-auto max-h-60 absolute z-10 text-background-dark bg-white shadow-md rounded-md w-full overflow-y-auto no-scrollbar">
                    {/* Search Input */}
                    <div className="py-1.5 px-3">
                        <div className="border border-background-normal cursor-pointer bg-white rounded-lg flex items-center py-2 px-2">
                            <img className="w-4" src="../../../../assets/icons/search.svg" alt="search" />
                            <input
                                className="border-none bg-white focus:outline-none pl-2 w-full placeholder:text-sm"
                                type="text"
                                placeholder={ t("search company name")}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)} // Step 3: Update searchText state
                            />
                        </div>
                    </div>

                    {/* Filtered Transportation List */}
                    {filteredList.length > 0 ? (
                        filteredList.map((company, index) => (
                            <li key={index} onClick={(e) => handleTransportation(e, company)}
                                className="bg-white hover:bg-action-hover cursor-pointer py-1.5 px-3 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                {company.text}
                            </li>
                        ))
                    ) : (
                        <li className="py-1.5 px-3 text-gray-dark text-xs sm:text-sm first-letter:capitalize">{ t('no results found')}</li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default TransportationDropdown;
